import React from "react";

const TrendingSurveys = ({  }) => {
  return (    
        <div className="col d-flex">
            <div className="right-card trending-card w-100 h-100 mb-0">
            <h4 className="fw-bold mb-4 ft-16">Trending Surveys</h4>
            <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                <div className="d-flex align-items-center gap-2">
                <div className="surveysname fw-bold ft-13">#Technology</div>
                <small className="surveysnumber fw-semibold ft-11">
                    2,480 surveys
                </small>
                </div>
                <div className="surveygrowth ft-12">+18%</div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                <div className="d-flex align-items-center gap-2">
                <div className="surveysname fw-bold ft-13">#Gaming</div>
                <small className="surveysnumber fw-semibold ft-11">
                    1,942 surveys
                </small>
                </div>
                <div className="surveygrowth ft-12">+15%</div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                <div className="d-flex align-items-center gap-2">
                <div className="surveysname fw-bold ft-13">#AI</div>
                <small className="surveysnumber fw-semibold ft-11">
                    1,628 surveys
                </small>
                </div>
                <div className="surveygrowth ft-12">+12%</div>
            </div>
            </div>
        </div>
    );
}

export default TrendingSurveys;
